(function() {
'use strict';

angular
    .module('TR')
    .service('preferences', preferences);

function preferences($q, $rootScope, localStorageProvider, preferencesHttpProvider, funcUtil) {
    const service = {
        get: decorate(get),
        set: decorate(set),
        getAllPreferences: decorate(getAllPreferences),
        setAllPreferences: decorate(setAllPreferences),
        clear,
        getFlightSortOrder,
        setFlightSortOrder,
        getHotelSortOrder,
        setHotelSortOrder
    };
    const defaultPrefs = {
        priceMode: TRPCONFIG.Domain.DefaultPriceMode,
        hotelSortOrder: getDefaultHotelSortOrder(),
        flightSortOrder: getDefaultFlightSortOrder(),
        flightClass: 0,
        smokingRoom: false,
        footerToolbar: true
    };
    let prefsPromise = getAllPreferences();
    const localPrefs = {};

    function get(key) {
        return getAllPreferences().then(prefs => prefs[key]);
    }

    function getDefaultHotelSortOrder() {
        return TRPCONFIG.Domain.HotelSearchOrder;
    }

    function getDefaultFlightSortOrder() {
        return TRPCONFIG.Domain.BestFitFlightSelection ? 10 : TRPCONFIG.Domain.FlightsSearchOrder;
    }

    function getFlightSortOrder(initial) {
        if (TRPCONFIG.Domain.SaveSortPreferences) {
            return decorate(get)('flightSortOrder');
        }
        if (initial) {
            localPrefs.flightSortOrder = getDefaultFlightSortOrder();
        }
        return $q.when(localPrefs.flightSortOrder || getDefaultFlightSortOrder());
    }

    function setFlightSortOrder(value) {
        if (TRPCONFIG.Domain.SaveSortPreferences) {
            return decorate(set)('flightSortOrder', value);
        }
        return $q.when(value);
    }
    function getHotelSortOrder(initial) {
        if (TRPCONFIG.Domain.SaveSortPreferences) {
            return decorate(get)('hotelSortOrder');
        }
        if (initial) {
            localPrefs.hotelSortOrder = getDefaultHotelSortOrder();
        }
        return $q.when(localPrefs.hotelSortOrder || getDefaultHotelSortOrder());
    }

    function setHotelSortOrder(value) {
        if (TRPCONFIG.Domain.SaveSortPreferences) {
            return decorate(set)('hotelSortOrder', value);
        }
        localPrefs.hotelSortOrder = value;
        return $q.when(value);
    }

    function set(key, val) {
        return getUser().then(user => {
            const defered = [$q.defer(), $q.defer()];

            if (val === null || val === undefined) {
                preferencesHttpProvider.remove(user, () => defered[0].resolve(), key);
                localStorageProvider.remove(() => defered[1].resolve(), key);
            } else {
                const prefs = {};
                prefs[key] = val;
                preferencesHttpProvider.set(user, () => defered[0].resolve(), prefs);
                localStorageProvider.set(() => defered[1].resolve(), prefs);
            }
            return all(defered).then(clear);
        });
    }

    function getAllPreferences() {
        return getUser().then(user => {
            const cacheKey = user.UserIdHash || 'no-hash';

            if (prefsPromise && prefsPromise.cacheKey === cacheKey) {
                return prefsPromise;
            }
            const defered = $q.defer();
            preferencesHttpProvider.get(user, prefs => {
                if (prefs) {
                    defered.resolve(prefs);
                } else {
                    localStorageProvider.get(prefs => defered.resolve(prefs));
                }
            });
            prefsPromise = defered.promise.then(prefs => angular.extend({}, defaultPrefs, prefs));
            prefsPromise.cacheKey = cacheKey;
            return prefsPromise;
        });
    }

    function setAllPreferences(prefs) {
        return getUser().then(user => {
            const defered = [$q.defer(), $q.defer()];
            preferencesHttpProvider.set(user, () => defered[0].resolve(), prefs);
            localStorageProvider.set(() => defered[1].resolve(), prefs);
            return all(defered).then(clear);
        });
    }

    function all(defered) {
        const promises = _.map(defered, d => d.promise);
        return $q.all(promises);
    }

    function clear() {
        prefsPromise = null;
    }

    function getUser() {
        return funcUtil.waitForValue(() => $rootScope.user);
    }

    // Copies all input/output to ensure that the preferences are not accidently mutated.
    function decorate(func) {
        return function(...args) {
            const argumentsCopy = _.map(args, a => angular.copy(a));
            const result = func.apply(service, argumentsCopy);
            return $q.when(result).then(r => angular.copy(r));
        };
    }

    return service;
}
})();
